export default {
	transpose(chord, transpose) {
		[ chord.base, chord.modifier ] = this.transposeBaseAndModifier(chord.base, chord.modifier, transpose);
		[ chord.bassBase, chord.bassModifier ] = this.transposeBaseAndModifier(chord.bassBase, chord.bassModifier, transpose);

		return chord;
	},

	transposeBaseAndModifier(base, modifier, transpose) {
		if (base === null) return [ null, null ];
		const index = this.getIndexOfKey(base, modifier);
		const key = this.getKeyByIndex(index + parseInt(transpose));
		return [ key.base, key.modifier ]
	},

	getKeyByIndex(index) {
		if (index < 0) {
			index = 12 + index;
		}

		if (index > 11) {
			index = index - 12;
		}

		var keys = this.keys()[index];

		return keys[0];
	},

	getIndexOfKey(base, modifier) {
		let returnIndex;
		this.keys().map((keys, index) => {
			if (keys.filter(key => this.isChordEqualsKey(base, modifier, key)).length > 0) {
				returnIndex = index;
			}
		});
		return returnIndex;
	},

	isChordEqualsKey(base, modifier, key) {
		return base.toUpperCase() === key.base && modifier === key.modifier;
	},

	keys() {
		return [
			[ { base: "C", modifier: null }, { base: "H", modifier: "#" } ],
			[ { base: "C", modifier: "#" }, { base: "D", modifier: "b" } ],
			[ { base: "D", modifier: null } ],
			[ { base: "D", modifier: "#" }, { base: "E", modifier: "b" } ],
			[ { base: "E", modifier: null }, { base: "F", modifier: "b" } ],
			[ { base: "F", modifier: null }, { base: "E", modifier: "#" } ],
			[ { base: "F", modifier: "#" }, { base: "G", modifier: "b" } ],
			[ { base: "G", modifier: null } ],
			[ { base: "G", modifier: "#" }, { base: "A", modifier: "b" } ],
			[ { base: "A", modifier: null } ],
			[ { base: "B", modifier: null }, { base: "B", modifier: "b" }, { base: "A", modifier: "#" } ],
			[ { base: "H", modifier: null }, { base: "B", modifier: "#" } ]
		];
	}
}
